import {
  IdTypeOptionValues,
  stateRequiredTypes,
  militaryBranchRequiredTypes,
  countryRequiredTypes,
} from '../constants/form-options';

export const useIdTypeState = <T extends string = IdTypeOptionValues>(idType: T) => {
  const showIdState = stateRequiredTypes.includes(idType as IdTypeOptionValues);
  const showMilitaryBranch = militaryBranchRequiredTypes.includes(idType as IdTypeOptionValues);
  const showIdCountry = countryRequiredTypes.includes(idType as IdTypeOptionValues);

  return {
    showIdState,
    showMilitaryBranch,
    showIdCountry,
  };
};
